import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Decorative, TopShop } from "@faire/design-tokens";
import { SERRANO } from "@faire/retailer-visitor-shared/consts/colors";
import { bpsToPercent } from "@faire/retailer-visitor-shared/lib/bpsToDecimalAndPercent";
import { useAssignSettingUpdateSaleColorCopy, useSettingUpdateSaleColorCopy } from "@faire/retailer-visitor-shared/settings/useSettingUpdateSaleColorCopy";
import { Avatar } from "@faire/web--source/slate/deprecated/Avatar";
import { TrophyIcon } from "@faire/web--source/slate/icons/Trophy";
import { Column, Flex, Row } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import React, { useEffect } from "react";
import styled, { css } from "styled-components";
var CollectionHeaderLogo = function(param) {
    var size = param.size, image = param.image, _param_isTopShop = param.isTopShop, isTopShop = _param_isTopShop === void 0 ? false : _param_isTopShop;
    // TODO: Address the actual image used here and force it to pad instead of crop. @Julian-Lannigan to follow up with Slate team to maybe figure out a better approach.
    // https://faire-wholesale.slack.com/archives/C01BU80K6GL/p1677187664529379
    var taggedImage = IImage.build(_object_spread_props(_object_spread({}, image), {
        tags: [
            "cloudinary_crop_pad"
        ]
    }));
    if (isTopShop) {
        return /*#__PURE__*/ _jsx("div", {
            children: /*#__PURE__*/ _jsx(Avatar, {
                size: size,
                image: taggedImage,
                borderColor: TopShop.shade.green,
                iconData: {
                    position: "bottomRight",
                    icon: /*#__PURE__*/ _jsx(TrophyIcon, {
                        color: TopShop.icon.green,
                        fill: TopShop.icon.green,
                        active: true,
                        width: size === "x-small" ? "16px" : "30px",
                        height: size === "x-small" ? "16px" : "30px"
                    })
                }
            })
        });
    } else {
        return /*#__PURE__*/ _jsx("div", {
            children: /*#__PURE__*/ _jsx(Avatar, {
                size: size,
                image: taggedImage
            })
        });
    }
};
export var CollectionHeader = function(param) {
    var collection = param.collection, collectionPromo = param.collectionPromo;
    var _useViewport = useViewport(), isMobile = _useViewport.isMobile, isTabletAndAbove = _useViewport.isTabletAndAbove;
    return /*#__PURE__*/ _jsxs(ColToRow, {
        children: [
            /*#__PURE__*/ _jsxs(HeaderDetails, {
                "data-test-id": "collection-header-details",
                children: [
                    isMobile ? /*#__PURE__*/ _jsxs(MobileCol, {
                        "data-test-id": "collection-mobile-header",
                        gap: "2x",
                        children: [
                            /*#__PURE__*/ _jsx(CollectionHeaderLogo, {
                                size: "x-small",
                                image: collection === null || collection === void 0 ? void 0 : collection.brand_logo_image,
                                isTopShop: collection === null || collection === void 0 ? void 0 : collection.brand_is_top_shop
                            }),
                            /*#__PURE__*/ _jsx(HeaderTag, {
                                collection: collection,
                                collectionPromo: collectionPromo
                            })
                        ]
                    }) : /*#__PURE__*/ _jsx(HeaderTag, {
                        collection: collection,
                        collectionPromo: collectionPromo
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        "data-test-id": "collection-name",
                        variant: "displayLSerifRegular",
                        children: collection === null || collection === void 0 ? void 0 : collection.name
                    }),
                    (collection === null || collection === void 0 ? void 0 : collection.description) ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(Spacer, {
                                height: "2x"
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                "data-test-id": "collection-description",
                                children: collection.description
                            })
                        ]
                    }) : null
                ]
            }),
            isTabletAndAbove ? /*#__PURE__*/ _jsx(Row, {
                justify: "right",
                "data-test-id": "collection-tabletAndAbove-avatar",
                children: /*#__PURE__*/ _jsx(CollectionHeaderLogo, {
                    size: "large",
                    image: collection === null || collection === void 0 ? void 0 : collection.brand_logo_image,
                    isTopShop: collection === null || collection === void 0 ? void 0 : collection.brand_is_top_shop
                })
            }) : null
        ]
    });
};
var HeaderTag = function(param) {
    var collection = param.collection, collectionPromo = param.collectionPromo;
    var _collection_active_display_promo;
    var shouldShowDiscountTag = collectionPromo === null || collectionPromo === void 0 ? void 0 : collectionPromo.discount_bps;
    var assignUpdateSaleColor = useAssignSettingUpdateSaleColorCopy();
    var isSettingUpdateSaleColor = useSettingUpdateSaleColorCopy();
    var shouldShowFreeDisplayTag = ((_collection_active_display_promo = collection.active_display_promo) === null || _collection_active_display_promo === void 0 ? void 0 : _collection_active_display_promo.type) === "FREE_DISPLAY";
    useEffect(function() {
        if (shouldShowDiscountTag) {
            assignUpdateSaleColor();
        }
    }, [
        assignUpdateSaleColor,
        shouldShowDiscountTag
    ]);
    var _collectionPromo_discount_bps, _collectionPromo_discount_bps1;
    return /*#__PURE__*/ _jsxs(Row, {
        align: "center",
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraphSansMedium",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "PcIdya",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Collection"
                        }
                    ]
                })
            }),
            shouldShowDiscountTag ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Spacer, {
                        width: "1x"
                    }),
                    /*#__PURE__*/ _jsx(DiscountTag, {
                        $isUpdateSaleColor: isSettingUpdateSaleColor,
                        children: /*#__PURE__*/ _jsx(Typography, {
                            variant: "paragraphSansMedium",
                            color: isSettingUpdateSaleColor ? SERRANO : Decorative.shade.orange,
                            children: shouldShowFreeDisplayTag ? /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                id: "moU1to",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Free display + "
                                    },
                                    {
                                        type: 1,
                                        value: "discountPercentageNumber"
                                    },
                                    {
                                        type: 0,
                                        value: "% off"
                                    }
                                ],
                                values: {
                                    discountPercentageNumber: bpsToPercent((_collectionPromo_discount_bps = collectionPromo === null || collectionPromo === void 0 ? void 0 : collectionPromo.discount_bps) !== null && _collectionPromo_discount_bps !== void 0 ? _collectionPromo_discount_bps : 0)
                                }
                            }) : /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                id: "YtA3nD",
                                defaultMessage: [
                                    {
                                        type: 1,
                                        value: "discountPercentageNumber"
                                    },
                                    {
                                        type: 0,
                                        value: "% off"
                                    }
                                ],
                                values: {
                                    discountPercentageNumber: bpsToPercent((_collectionPromo_discount_bps1 = collectionPromo === null || collectionPromo === void 0 ? void 0 : collectionPromo.discount_bps) !== null && _collectionPromo_discount_bps1 !== void 0 ? _collectionPromo_discount_bps1 : 0)
                                }
                            })
                        })
                    })
                ]
            }) : null
        ]
    });
};
var DiscountTag = styled.div.withConfig({
    componentId: "sc-dfcc9b3d-0"
})([
    "",
    " padding:",
    ";"
], function(param) {
    var $isUpdateSaleColor = param.$isUpdateSaleColor;
    return !$isUpdateSaleColor && css([
        "background-color:",
        ";"
    ], Decorative.tint.orange);
}, getSpacing(4, 6));
var ColToRow = styled(Flex).attrs({
    align: {
        mobileAndAbove: "center",
        tabletAndAbove: "stretch"
    },
    justify: {
        mobileAndAbove: "normal",
        tabletAndAbove: "space-between"
    },
    direction: {
        mobileAndAbove: "column",
        tabletAndAbove: "row"
    }
}).withConfig({
    componentId: "sc-dfcc9b3d-1"
})([
    "width:100%;"
]);
var MobileCol = styled(Row).attrs({
    align: "center"
}).withConfig({
    componentId: "sc-dfcc9b3d-2"
})([
    "margin-bottom:",
    ";"
], getSpacing("1x"));
var HeaderDetails = styled(Column).attrs({
    align: "flex-start",
    justify: "flex-start"
}).withConfig({
    componentId: "sc-dfcc9b3d-3"
})([
    "width:100%;z-index:1;",
    "{flex-basis:60%;}",
    "{flex-basis:50%;}",
    "{flex-basis:100%;padding:32px 16px 0;}"
], responsiveMediaQueries.desktopAndAbove, responsiveMediaQueries.tablet, responsiveMediaQueries.mobile);
